import React, { useState } from 'react'

function Contactus() {
    const [inputs, setInputs] = useState(["", "", ""]);

    const handleChange = (e) => {
        let target = e.target;
        let index = -1;
        switch(target.id)
        {
            case "fname":
                index = 0;
                if (target.value.split(" ").length > 1
                    && target.value.split(" ")[0].length > 2
                    && target.value.split(" ")[1].length > 2)
                    setInputs(inputs.map((v, k) => { return ((k === index) ?  target.value : v)}));
                else
                    setInputs(inputs.map((v, k) => { return ((k === index) ?  "" : v)}));
            break;
            case "email":
                const regx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                index = 1;
                if (regx.test(target.value))
                    setInputs(inputs.map((v, k) => { return ((k === index) ?  target.value : v)}));
                else
                    setInputs(inputs.map((v, k) => { return ((k === index) ?  "" : v)}));
            break;
            case "message":
                index = 2;
                if (target.value.length > 29)
                    setInputs(inputs.map((v, k) => { return ((k === index) ?  target.value : v)}));
                else
                    setInputs(inputs.map((v, k) => { return ((k === index) ?  "" : v)}));
            break;
            default:
        }
        console.log(target.value.length);
        if (index > -1)
            target.style = "border-color: "+(inputs[index].length === 0 ? "rgb(216 2 2 / 71%)" : "rgb(41 43 62 / 50%);");
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (inputs.filter((v, k) => (v.length === 0)).length === 0)
        {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "fullName" : inputs[0], "email" : inputs[1], "message": inputs[2]})
            };
            fetch('https://leetask.herokuapp.com/api/contactus', requestOptions)
            .then(response => response.json());
            (e.target).querySelector("#fname").value = "";
            (e.target).querySelector("#fname").style = "rgb(41 43 62 / 50%);";
            (e.target).querySelector("#email").value = "";
            (e.target).querySelector("#email").style = "rgb(41 43 62 / 50%);";
            (e.target).querySelector("#message").value = "";
            (e.target).querySelector("#message").style = "rgb(41 43 62 / 50%);";
        }
    }

    return (
        <div id="contactus" className="container">
            <h3>Contact us</h3>
            <form onSubmit={handleSubmit} className="contact_form">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <input id="fname" type="text" placeholder="Full Name*" onChange={handleChange} required/>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <input id="email" type="text" placeholder="Email*" onChange={handleChange} required/>
                    </div>
                </div>
                <div className="row">
                    <textarea id="message" className="col" placeholder="*Your Message here ..." onChange={handleChange} required></textarea>
                </div>
                <div className="row">
                    <input type="submit" value="Send"/>
                </div>
            </form>
        </div>
    )
}

export default Contactus
